import { AnketaAnswerRadio } from './AnketaAnswerRadio';

export default AnketaAnswerRadio;